import React from 'react';
import { View } from './base_components';

require('../css/progress.less');

type Props = {
  style?: any;
  color?: string;
};

export default class ProgressSpinner extends React.PureComponent<Props> {
  render() {
    const { style, color } = this.props;
    const extra = {};
    if (color) {
      extra.borderColor = color;
    }
    return <View style={[style, extra]} className='progress-spinner' />;
  }
}
